import store from '@/redux/store';

const getFlowProgress = (flow: string, step: string) =>
{
	const state = store.getState();
	if (!state.support.flow) return null;
	if (state.support.flow.key !== flow) return null;
	if (!state.support.flow.progress) return null;

	// Return step progress
	return state.support.flow.progress[step];
};

export default getFlowProgress;
